<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="SMS 전송 내역 조회"
      desc="SMS 전송 현황을 조회할 수 있습니다."
    ></admin-filter>

    <!--<div class="btn-group-justify-end">
      <button @click="$router.push('sms/create')" class="button is-primary">SMS 전송</button>
    </div>-->

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="target" slot-scope="props">
        {{ props.item.target===0? '일반회원':props.item.target===2?'마케팅정보수신동의회원':props.item.target }}
      </div>
      <div slot="msg" slot-scope="props">
        <span class="unselect"
              style="text-decoration: underline"
              @click="$router.push(`sms/create?id=${props.item.id}`)">{{ props.item.msg }}</span>
      </div>
    </admin-table>
  </div>
</template>
<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: "SmsList",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {}
    },
    methods: {
      init() {
        this.initializing('sms_send', 'sms/send/multiple');
      },
      getDataFromServer() {
        this.getData();
      },
    }
  }
</script>
<style lang="stylus" scoped>
</style>
